import styled, { useTheme } from 'styled-components';
import Modal from '../../../components/Modal';
import {
  BodyLarge,
  ParagraphLargeText,
  ParagraphSmallText,
} from '../../../components/Texts';
import Button from '../../../components/Button';
import { formatUSD } from '../../../common/currency';
import { formatDate } from '../../../common/date';
import {
  useGetCurrentGiveAwayQuery,
  useJoinGiveAwayMutation,
} from '../../../redux/api/authorized/giveAway';
import { useSelector } from 'react-redux';
import { selectPrivyToken } from '../../../redux/slices/auth';
import { useState } from 'react';

const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
  text-align: center;
  gap: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledModal = styled(Modal)`
  .modal-content {
    overflow: hidden;
    max-height: 700px;
  }
`;

const GiveAway = ({ onClose }) => {
  const privyToken = useSelector(selectPrivyToken);
  const [loading, setLoading] = useState(false);
  const { data: giveAway, refetch } = useGetCurrentGiveAwayQuery(undefined, {
    skip: !privyToken,
  });

  const [joinGiveAway] = useJoinGiveAwayMutation();

  const theme = useTheme();

  return (
    <StyledModal onClose={onClose}>
      <ContentContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <ParagraphLargeText>{'JOIN THE GIVEAWAY'}</ParagraphLargeText>
          <BodyLarge>
            And participate for the chance of winning{' '}
            <span style={{ fontWeight: 700 }}>
              {formatUSD(giveAway.usdcAmount)}
            </span>{' '}
            worth of ${giveAway.tokenSymbol}
          </BodyLarge>
        </div>
        <img src={giveAway.logoUrl} width={160} height={160} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <ParagraphSmallText style={{ fontWeight: 700 }}>
            STEPS
          </ParagraphSmallText>
          <div>
            <ParagraphSmallText style={{ fontWeight: 500 }}>
              1. Follow{' '}
              <a
                style={{ color: theme.text.regular }}
                href={'https://x.com/deksxyz'}
                target='_blank'
                rel='noopener noreferrer'
              >
                Deks on Twitter
              </a>
            </ParagraphSmallText>
            <ParagraphSmallText style={{ fontWeight: 500 }}>
              2. Follow{' '}
              <a
                style={{ color: theme.text.regular }}
                href={giveAway.twitterUrl}
                target='_blank'
                rel='noopener noreferrer'
              >
                {giveAway.tokenName} on Twitter
              </a>
            </ParagraphSmallText>
            <ParagraphSmallText style={{ fontWeight: 500 }}>
              3. Like, share and repost{' '}
              <a
                style={{ color: theme.text.regular }}
                href={giveAway.twitterPostUrl}
                target='_blank'
                rel='noopener noreferrer'
              >
                giveaway post
              </a>
            </ParagraphSmallText>
            <ParagraphSmallText style={{ fontWeight: 500 }}>
              4. Click on Join now
            </ParagraphSmallText>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <ParagraphSmallText style={{ fontSize: 12, fontWeight: 500 }}>
            The winner will be announce through twitter the{' '}
            {formatDate(new Date(giveAway.endDate))}
          </ParagraphSmallText>
          <Button
            loading={loading}
            disabled={giveAway.joined}
            fullWidth
            onClick={async () => {
              setLoading(true);
              await joinGiveAway({ giveAwayId: giveAway.id });
              await refetch();
              setLoading(false);
            }}
          >
            {giveAway.joined ? 'ALREADY JOINED' : 'JOIN NOW'}
          </Button>
        </div>
      </ContentContainer>
    </StyledModal>
  );
};

export default GiveAway;
